export function getSheduleInformation() {
    return {
        "data": {
            "trayectoHorariosCercanias": [
                {
                    "origen": {
                        "codigoEstacion": "35605",
                        "descripcionEstacion": "ALCORCON"
                    },
                    "destino": {
                        "codigoEstacion": "60104",
                        "descripcionEstacion": "VALDEMORO"
                    },
                    "alerta": null,
                    "horario": {
                        "salida": "09:13:00",
                        "salidaReal": "09:13:00",
                        "llegada": "10:10:00",
                        "llegadaReal": "10:10:00",
                        "duracion": "00:57:00",
                        "duracionReal": "00:57:00"
                    },
                    "tramos": [
                        {
                            "origen": {
                                "codigoEstacion": "35605",
                                "descripcionEstacion": "ALCORCON"
                            },
                            "destino": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "horario": {
                                "salida": "09:13:00",
                                "salidaReal": "09:13:00",
                                "llegada": "09:35:00",
                                "llegadaReal": "09:35:00",
                                "duracion": "00:22:00",
                                "duracionReal": "00:22:00"
                            },
                            "lineaOrigen": "C5",
                            "lineaDestino": "C5",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "19580",
                            "accesible": "NO"
                        },
                        {
                            "origen": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "destino": {
                                "codigoEstacion": "60104",
                                "descripcionEstacion": "VALDEMORO"
                            },
                            "horario": {
                                "salida": "09:42:00",
                                "salidaReal": "09:42:00",
                                "llegada": "10:10:00",
                                "llegadaReal": "10:10:00",
                                "duracion": "00:28:00",
                                "duracionReal": "00:28:00"
                            },
                            "lineaOrigen": "C3",
                            "lineaDestino": "C3",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "20020",
                            "accesible": "NO"
                        }
                    ]
                },
                {
                    "origen": {
                        "codigoEstacion": "35605",
                        "descripcionEstacion": "ALCORCON"
                    },
                    "destino": {
                        "codigoEstacion": "60104",
                        "descripcionEstacion": "VALDEMORO"
                    },
                    "alerta": null,
                    "horario": {
                        "salida": "09:18:00",
                        "salidaReal": "09:18:00",
                        "llegada": "10:10:00",
                        "llegadaReal": "10:10:00",
                        "duracion": "00:52:00",
                        "duracionReal": "00:52:00"
                    },
                    "tramos": [
                        {
                            "origen": {
                                "codigoEstacion": "35605",
                                "descripcionEstacion": "ALCORCON"
                            },
                            "destino": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "horario": {
                                "salida": "09:18:00",
                                "salidaReal": "09:18:00",
                                "llegada": "09:40:00",
                                "llegadaReal": "09:40:00",
                                "duracion": "00:22:00",
                                "duracionReal": "00:22:00"
                            },
                            "lineaOrigen": "C5",
                            "lineaDestino": "C5",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "19582",
                            "accesible": "NO"
                        },
                        {
                            "origen": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "destino": {
                                "codigoEstacion": "60104",
                                "descripcionEstacion": "VALDEMORO"
                            },
                            "horario": {
                                "salida": "09:42:00",
                                "salidaReal": "09:42:00",
                                "llegada": "10:10:00",
                                "llegadaReal": "10:10:00",
                                "duracion": "00:28:00",
                                "duracionReal": "00:28:00"
                            },
                            "lineaOrigen": "C3",
                            "lineaDestino": "C3",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "20020",
                            "accesible": "NO"
                        }
                    ]
                },
                {
                    "origen": {
                        "codigoEstacion": "35605",
                        "descripcionEstacion": "ALCORCON"
                    },
                    "destino": {
                        "codigoEstacion": "60104",
                        "descripcionEstacion": "VALDEMORO"
                    },
                    "alerta": null,
                    "horario": {
                        "salida": "09:36:00",
                        "salidaReal": "09:36:00",
                        "llegada": "10:37:00",
                        "llegadaReal": "10:37:00",
                        "duracion": "01:01:00",
                        "duracionReal": "01:01:00"
                    },
                    "tramos": [
                        {
                            "origen": {
                                "codigoEstacion": "35605",
                                "descripcionEstacion": "ALCORCON"
                            },
                            "destino": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "horario": {
                                "salida": "09:36:00",
                                "salidaReal": "09:36:00",
                                "llegada": "09:58:00",
                                "llegadaReal": "09:58:00",
                                "duracion": "00:22:00",
                                "duracionReal": "00:22:00"
                            },
                            "lineaOrigen": "C5",
                            "lineaDestino": "C5",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "19586",
                            "accesible": "NO"
                        },
                        {
                            "origen": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "destino": {
                                "codigoEstacion": "60104",
                                "descripcionEstacion": "VALDEMORO"
                            },
                            "horario": {
                                "salida": "10:09:00",
                                "salidaReal": "10:09:00",
                                "llegada": "10:37:00",
                                "llegadaReal": "10:37:00",
                                "duracion": "00:28:00",
                                "duracionReal": "00:28:00"
                            },
                            "lineaOrigen": "C3",
                            "lineaDestino": "C3",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "20022",
                            "accesible": "NO"
                        }
                    ]
                },
                {
                    "origen": {
                        "codigoEstacion": "35605",
                        "descripcionEstacion": "ALCORCON"
                    },
                    "destino": {
                        "codigoEstacion": "60104",
                        "descripcionEstacion": "VALDEMORO"
                    },
                    "alerta": null,
                    "horario": {
                        "salida": "09:46:00",
                        "salidaReal": "09:46:00",
                        "llegada": "10:37:00",
                        "llegadaReal": "10:37:00",
                        "duracion": "00:51:00",
                        "duracionReal": "00:51:00"
                    },
                    "tramos": [
                        {
                            "origen": {
                                "codigoEstacion": "35605",
                                "descripcionEstacion": "ALCORCON"
                            },
                            "destino": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "horario": {
                                "salida": "09:46:00",
                                "salidaReal": "09:46:00",
                                "llegada": "10:08:00",
                                "llegadaReal": "10:08:00",
                                "duracion": "00:22:00",
                                "duracionReal": "00:22:00"
                            },
                            "lineaOrigen": "C5",
                            "lineaDestino": "C5",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "20768",
                            "accesible": "NO"
                        },
                        {
                            "origen": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "destino": {
                                "codigoEstacion": "60104",
                                "descripcionEstacion": "VALDEMORO"
                            },
                            "horario": {
                                "salida": "10:09:00",
                                "salidaReal": "10:09:00",
                                "llegada": "10:37:00",
                                "llegadaReal": "10:37:00",
                                "duracion": "00:28:00",
                                "duracionReal": "00:28:00"
                            },
                            "lineaOrigen": "C3",
                            "lineaDestino": "C3",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "20022",
                            "accesible": "NO"
                        }
                    ]
                },
                {
                    "origen": {
                        "codigoEstacion": "35605",
                        "descripcionEstacion": "ALCORCON"
                    },
                    "destino": {
                        "codigoEstacion": "60104",
                        "descripcionEstacion": "VALDEMORO"
                    },
                    "alerta": null,
                    "horario": {
                        "salida": "09:56:00",
                        "salidaReal": "09:56:00",
                        "llegada": "10:54:00",
                        "llegadaReal": "10:54:00",
                        "duracion": "00:58:00",
                        "duracionReal": "00:58:00"
                    },
                    "tramos": [
                        {
                            "origen": {
                                "codigoEstacion": "35605",
                                "descripcionEstacion": "ALCORCON"
                            },
                            "destino": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "horario": {
                                "salida": "09:56:00",
                                "salidaReal": "09:56:00",
                                "llegada": "10:18:00",
                                "llegadaReal": "10:18:00",
                                "duracion": "00:22:00",
                                "duracionReal": "00:22:00"
                            },
                            "lineaOrigen": "C5",
                            "lineaDestino": "C5",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "19588",
                            "accesible": "NO"
                        },
                        {
                            "origen": {
                                "codigoEstacion": "18000",
                                "descripcionEstacion": "MADRID - ATOCHA CERCANÍAS"
                            },
                            "destino": {
                                "codigoEstacion": "60104",
                                "descripcionEstacion": "VALDEMORO"
                            },
                            "horario": {
                                "salida": "10:26:00",
                                "salidaReal": "10:26:00",
                                "llegada": "10:54:00",
                                "llegadaReal": "10:54:00",
                                "duracion": "00:28:00",
                                "duracionReal": "00:28:00"
                            },
                            "lineaOrigen": "C3",
                            "lineaDestino": "C3",
                            "viaOrigen": null,
                            "viaDestino": null,
                            "codigoTren": "20114",
                            "accesible": "NO"
                        }
                    ]
                }
            ]
        }
    }
  }
 
  
  export function getConsultIncidence() {
    return {
        "data": {
            "nucleo": "31",
            "descNucleo": "Cadiz",
            "aviso": [
                {
                    "inicio": "2024-02-15",
                    "lineas": null,
                    "sublineas": null,
                    "texto": "Con motivo de la celebración de las fiestas de Carnaval de Chiclana de \nla Frontera y San Fernando, la programación de trenes Trambahía de los días 16, 17 y 18 de \nfebrero se verá afectada por la modificación del origen y del destino de algunos trenes. \nRogamos consulten horarios antes de la realización de su viaje en las citadas jornadas. \nDisculpen las molestias."
                },
                {
                    "inicio": "2024-02-15 07:58:00.0",
                    "lineas": "C1, T1",
                    "sublineas": "C1, T1",
                    "texto": "Ascensor de vía 2 de la estación de Segunda Aguada fuera de servicio. \nEstación inaccesible para personas con movilidad reducida, para trenes con destino Cádiz. \nDisculpen las molestias"
                },
                {
                    "inicio": "2024-02-15 06:17:00.0",
                    "lineas": "C1",
                    "sublineas": "C1",
                    "texto": "Por problemas en las instalaciones de la estación de Aeropuerto de \nJerez, todos los trenes efectuarán su parada en via 3."
                },
                {
                    "inicio": "2023-12-27 21:05:00.0",
                    "lineas": "C1, T1",
                    "sublineas": "C1, C1a, T1",
                    "texto": "PARA VALIDAR EN LOS CONTROLES DE ACCESO DE LAS \nESTACIONES SAQUE SIEMPRE SU TARJETA O ABONO DE TRANSPORTE DE LA \nCARTERA, EN EVITACIÓN DE CARGOS INDEBIDOS A TARJETAS DE CRÉDITO. Gracias \npor su colaboración."
                },
                {
                    "inicio": "2023-12-14 11:32:00.0",
                    "lineas": "C1, T1",
                    "sublineas": "C1, C1a, T1",
                    "texto": "Renfe informa de que, por motivos de seguridad, no se permite el \nacceso a los trenes con patinetes o vehículos eléctricos similares. Quedan excluidos de esta \nprohibición los vehículos para personas con movilidad reducida y las bicicletas eléctricas. \nGracias por su colaboración."
                }
            ]
        }
    }
  }
    